import React from 'react';
import { PayloadStates } from '@lore/utils';
import MetricLoader from '../../MetricLoader';
import moment from 'moment-timezone';
import ComparisonMetric from '../../ComparisonMetric';
import useInvitationsCreated from './useInvitationsCreated';

export default function PartnerInvitationsCreated(props) {
  const { network, schoolStart, schoolEnd, titleOnly = false } = props;

  const title = `(den) # total invites sent`;

  const previousSchoolStart = moment(schoolStart).subtract(1, 'year').toISOString();

  const previousInvitations = useInvitationsCreated(network, {
    start: titleOnly ? undefined : previousSchoolStart,
    end: schoolStart
  });

  const newInvitations = useInvitationsCreated(network, {
    start: schoolStart,
    end: schoolEnd
  });

  if (
    previousInvitations.state === PayloadStates.FETCHING ||
    newInvitations.state === PayloadStates.FETCHING
  ) {
    return (
      <MetricLoader
        name={title}
      />
    );
  }

  return (
    <ComparisonMetric
      name={title}
      value={newInvitations.meta.totalCount}
      previousValue={previousInvitations.meta.totalCount}
      titleOnly={titleOnly}
    />
  );
}
